PACK_SELECTION_MODIF = [];

class SideCart extends HTMLElement {
  constructor() {
    super();

    this.initVariables();
    this.initCssVariables();
    this.bindEvents();
    this.getCart();
    scrollTouchInit();
    this.querySelector(".sidecart-form__slider_form")
      ? this.initReaSlider()
      : null;
  }

  initReaSlider() {
    const swiper = new Swiper(
      this.querySelector(".sidecart-form__slider_form .swiper"),
      {
        // Optional parameters
        direction: "horizontal",
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
        },

        autoplay: {
          delay: Number(
            this.querySelector(".sidecart-form__slider_form").dataset.duration
          ),
        },
        // If we need pagination
        pagination: {
          el: this.querySelector(".swiper-pagination"),
        },
      }
    );
  }

  /**
   * init all variables used in side cart
   */
  initVariables() {
    this.body = document.querySelector("body");
    this.openButtons = document.querySelectorAll(
      '[href="/cart"],[href="/en/cart"]'
    );
    this.closePrevButtons = this.querySelectorAll(".sidecart__close-prev");
    this.nextStepButtons = this.querySelectorAll('button[name="next-step"]');
    this.cart = null;
    this.first_load = true;
    this.numberOfSteps = this.querySelectorAll(
      ".step-index-content[data-step-index]"
    ).length;
    this.current_step = 0;
  }

  /**
   * init all css variables used in side cart
   */
  initCssVariables() {
    document.documentElement.style.setProperty(
      "--cart-drawer-footer-height",
      document.querySelector(".sidecart__footer").offsetHeight + "px"
    );

    document.documentElement.style.setProperty(
      "--cart-drawer-header-height",
      document.querySelector(".sidecart__header").offsetHeight + "px"
    );

    // In main.js
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight / 100}px`
    );
  }

  /**
   * bind all events used in side cart
   */
  bindEvents() {
    window.addEventListener("resize", this.initCssVariables.bind(this));
    this.openButtons.forEach((button) => {
      button.addEventListener("click", this.openCart.bind(this));
    });

    if (this.querySelector("[data-open-details]")) {
      this.querySelectorAll("[data-open-details]").forEach((button) => {
        button.addEventListener("click", this.openPackContent.bind(this));
      });

      this.querySelectorAll("[data-modif-pack]").forEach((button) => {
        button.addEventListener("click", this.modifPackContent.bind(this));
      });
    }

    // TO EDIT : close cart or prev step when click on back/close button
    this.closePrevButtons.forEach((button) => {
      button.addEventListener("click", this.closePrevActions.bind(this));
    });

    this.initFooterEvents();

    // Bind click outside of cart and close it
    document.addEventListener("click", (e) => {
      if (
        e.target.closest(".cc-cart-drawer") === null &&
        e.target.closest('[href="/cart"]') === null &&
        e.target.closest('[href="/en/cart"]') === null &&
        e.target.closest(".sidecart__close") === null &&
        e.target.closest("quick-add-to-cart") === null &&
        window.blockClose != true
      ) {
        this.closeCart();
      }
    });

    this.addEventListener(
      "dispatch:cart-drawer:open",
      this.openCart.bind(this)
    );
    this.addEventListener(
      "dispatch:cart-drawer:close",
      this.closeCart.bind(this)
    );

    this.addEventListener("dispatch:cart-drawer:refresh", async (evt) => {
      await this.getCart();
      this.updateCartCount();
      this.updateCartItems(evt.detail?.new_item_added);
      this.querySelectorAll("gifts-cart").forEach((el) =>
        el.dispatchEvent(new CustomEvent("progressbar:update"))
      );
      if (evt.detail?.nextStep == true) {
        this.nextStep();
      }
      document
        .querySelectorAll("quick-add-to-cart .is-loading")
        .forEach((el) =>
          el.classList.remove("is-loading", "cart-item--loading")
        );
    });

    this.addEventListener("dispatch:cart-drawer:recommendations", (evt) => {
      this.updateRecommendations(evt.detail.productId);
    });
  }

  openPackContent(e) {
    e.currentTarget
      .closest(".cart-item")
      .querySelector(".pack-content__container")
      .classList.toggle("hidden");
  }

  modifPackContent(e) {
    document.querySelector("pack-builder-modal").resetDrawer();
    this.closeCart();
    line_item = e.currentTarget.dataset.lineModif;

    PACK_SELECTION = {
      sachets_times: e.currentTarget.getAttribute("data-modif-content-pack"),
      sachets_quantity: e.currentTarget.getAttribute("data-quantity-product"),
      product_id: e.currentTarget.getAttribute("data-id-modif"),
      product_variant_id: e.currentTarget.getAttribute("data-variant-id-modif"),
      pack_items: JSON.parse(
        e.currentTarget.getAttribute("data-modif-product-pack-items")
      ),
      sachets_times: parseInt(
        e.currentTarget.getAttribute("data-modif-product-sachets-number")
      ),
      sachets_number: parseInt(
        e.currentTarget.getAttribute("data-modif-product-sachets-times")
      ),
      line_item: parseInt(line_item),
    };

    document.querySelector("pack-builder-modal").openDrawerSidecart();
    document.querySelector("pack-builder-modal").updatPackSelection();
  }
  /**
   * init all es used in side cart footer
   */
  initFooterEvents() {
    this.nextStepButtons = this.querySelectorAll(
      'button[name="next-step"].ignore-step:not([data-subscribe])'
    );
    // Bind click on next step button
    this.nextStepButtons.forEach((button) =>
      button.addEventListener("click", this.nextStep.bind(this))
    );

    this.addFeaturedProductButtons = this.querySelectorAll(
      '[data-action-type="featured_product"]'
    );
    // Bind click on add to cart featured upsells
    this.addFeaturedProductButtons.forEach((button) =>
      button.addEventListener("click", this.addFeaturedProduct.bind(this))
    );

    this.querySelectorAll("button[data-subscribe]").forEach((button) => {
      button.addEventListener("click", this.subscribeActions.bind(this));
    });
  }

  /**
   * open cart when click on cart icon or cart link
   * @param {object} evt - Event object.
   */
  openCart(e) {
    e?.preventDefault();
    document.querySelector("quick-add-drawer").close();
    this.classList.add("sidecart--open");
    document.querySelector("body").classList.add("shadow-cart");

  }

  /**
   * close cart when click on cart icon or cart link
   */
  closeCart() {
    this.classList.add("sidecart--close-animation");
    document.querySelector("body").classList.add("fade-out");
    setTimeout(
      function () {
        this.classList.remove("sidecart--close-animation");
        this.classList.remove("sidecart--open");
        document
          .querySelector("body")
          .classList.remove("shadow-cart", "fade-out");
      }.bind(this),
      500
    );
  }

  /**
   * close cart or previous step when click on back/close button
   */
  closePrevActions() {
    if (this.current_step == 0) {
      this.closeCart();
    } else {
      this.previousStep();
    }
  }

  /**
   * refresh cart when add or remove product
   */
  async getCart() {
    this.cart = await fetch("/cart.js").then((response) => response.json());
    this.querySelectorAll("[data-cart-price]").forEach((el) =>
      el.setAttribute(
        "data-cart-price",
        parseFloat(this.cart.total_price / 100)
      )
    );
    if (this.first_load) {
      this.first_load = false;
      this.updateRecommendations(this.cart.items[0]?.product_id);
    }

    document.querySelector("side-cart")?.updateCartCount();

    this.initCssVariables();
  }

  /**
   * Refresh cart items and recommendations.
   */
  async refreshCart() {
    await this.updateCartItems();
    this.updateRecommendations(this.cart.items[0]?.product_id);
  }

  async refreshCartAndOpen(new_item_added = false) {
    this.getCart();
    await this.updateCartItems(new_item_added);
    this.openCart();
  }

  /**
   * Refresh cart items and recommendations.
   */
  updateRecommendations() {
    this.updateRecommendations(this.cart.items[0]?.product_id);
  }

  /**
   * Go to gift step when click on change gift button
   */
  goGiftStep(index) {
    const gift_step = this.querySelector(
      `.gifts-cart--step[data-gift-number="${index}"]`
    );
    const gift_index = gift_step.dataset.stepIndex;
    this.current_step = gift_index;
    this.gift_index = index;
    this.updateStep("gift");
  }

  /**
   * Updates the cart items.
   * @returns {Promise}
   */
  async updateCartItems(new_item_added = false) {
    try {
      let sections = this.getSectionsToRender().map(
        (section) => section.section
      );

      const response = await fetch(`?sections=${[...new Set(sections)]}`);
      const data = await response.json();

      if (!response.ok) throw new Error(response.status);

      this.getSectionsToRender().forEach((section) => {
        // Check if cart is empty and remove recommendations if so
        const items_count = document.querySelectorAll(".cart-item").length;
        if (items_count == 0 && this.querySelector("product-recommendations")) {
          this.querySelector("product-recommendations").innerHTML = "";
        }

        const sectionEl = document.getElementById(section.id);
        if (!sectionEl) return;

        // if selector has multiple items
        // get all items by key if exists
        if (section.multiple) {
          let selectors = sectionEl.querySelectorAll(section.selector);

          selectors.forEach((selector) => {
            const el = selector || sectionEl;
            const new_selector =
              section.selector +
              (selector.dataset.variantId
                ? `[data-variant-id="${selector.dataset.variantId}"]`
                : "");

            const new_html = this.getElementHTML(
              data[section.section],
              new_selector
            );

            el.innerHTML = new_html;
          });
        } else {
          // if selector has only one item
          const el = sectionEl.querySelector(section.selector);

          if (el) {
            el.innerHTML = this.getElementHTML(
              data[section.section],
              section.selector
            );
          }

          if (section.selector == ".sidecart__footer") {
            this.initFooterEvents();
          }
        }
      });

      if (new_item_added) {
        this.updateRecommendations(this.cart.items[0]?.product_id);
      }

      const sideCart = document.querySelector("side-cart");
      sideCart.updateStep();

      document
        .querySelector("subscription-upsell")
        ?.classList.remove("is-loading");
      document
        .querySelector(".sidecart__footer")
        .classList.remove("sidecart__footer--loading");

      if (document.querySelectorAll("#cart-items .cart-item").length > 0) {
        document.querySelector(".sidecart__footer").classList.remove("hidden");
      } else {
        document.querySelector(".sidecart__footer").classList.add("hidden");
      }

      this.updateSubscriptionYearlyEconomy();
      scrollTouchInit();
      if (this.querySelector("[data-open-details]")) {
        this.querySelectorAll("[data-open-details]").forEach((button) => {
          button.addEventListener("click", this.openPackContent.bind(this));
        });

        this.querySelectorAll("[data-modif-pack]").forEach((button) => {
          button.addEventListener("click", this.modifPackContent.bind(this));
        });
      }

      this.initCssVariables();
      window.initLazyImages();
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Updates the subscription yearly economy on subscription upsell if exists.
   */
  updateSubscriptionYearlyEconomy() {
    let subscription_upsell = document.querySelector("subscription-upsell");

    if (subscription_upsell) {
      let yearly_economy = subscription_upsell.querySelector(
        "[data-yearly-economy]"
      );
      let frequency = subscription_upsell.querySelector(
        ".subscription-upsell__select"
      ).value;
      let economy = parseFloat(
        subscription_upsell
          .querySelector(`[data-subscription-upsell-economy-total] span`)
          .innerHTML.replace("€", "")
      );

      let amount_economy_yearly = (12 / frequency) * economy;
      yearly_economy.innerHTML = amount_economy_yearly.toFixed(2);
    }
  }

  /**
   * Returns an array of objects containing required section details.
   * @returns {Array}
   */
  getSectionsToRender() {
    const cartDrawerId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    let sections = [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".cart-items-container",
        multiple: true,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".sidecart__upsell-collections .cart-card-mini__actions",
        multiple: true,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".subscription-upsell__subtotal",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".sidecart__footer",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".sidecart__featured-product",
        multiple: true,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".gifts-cart:not(.gifts-cart--step)",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: "[data-gift-number='1']",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: "[data-gift-number='2']",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: "[data-gift-number='3']",
        multiple: false,
      },
      {
        id: "sidecart",
        section: cartDrawerId,
        selector: ".subscription-upsell__subtitle",
        multiple: false,
      },
    ];
    return sections;
  }

  /**
   * Gets the innerHTML of an element.
   * @param {string} html - Section HTML.
   * @param {string} selector - CSS selector for the element to get the innerHTML of.
   * @returns {string}
   */
  getElementHTML(html, selector) {
    const tmpl = document.createElement("template");
    tmpl.innerHTML = html;

    const el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : "";
  }

  /**
   * Updates the cart recommendations.
   * @param {string} productId - The product id for which to find recommendations.
   */
  updateRecommendations(productId) {
    this.recommendations =
      this.recommendations || document.getElementById("cart-recommendations");
    if (!this.recommendations) return;

    if (productId) {
      this.recommendations.dataset.productId = productId;
      this.recommendations.init();
    } else {
      this.recommendations.innerHTML = "";
    }
    setTimeout(this.initCssVariables, 2000);
  }

  /**
   * Updates the cart count.
   */
  updateCartCount() {
    const cartCounts = document.querySelectorAll(
      "#sidecart-cart-count [data-cart-count], .header__cart-count-number"
    );
    if (cartCounts.length == 0) return;

    cartCounts.forEach((cartCount) => {
      cartCount.innerHTML = this.cart.item_count;
    });
  }

  /**
   * Go to next step (click on next button)
   */
  nextStep(bypassGift) {
    let isGiftStep =
      this.querySelector(
        `[data-step-index="${this.current_step}"].gifts-cart--step`
      ) || false;

    this.current_step++;

    if (reassuranceOnlyFirstStep) {
      document.querySelector(".sidecart-form__slider_form")
        ? document
          .querySelector(".sidecart-form__slider_form")
          .classList.add("hidden")
        : null;
    }

    if (isGiftStep) {
      this.current_step = 0;
      this.updateStep();
      return;
    }

    // Check if step is a gift step
    let isGiftStepAfter =
      this.querySelector(
        `[data-step-index="${this.current_step}"][data-action-type="gifts"]`
      ) || false;

    if (isGiftStepAfter) {
      window.location.href = "/checkout/";
      return;
    }

    if (this.current_step <= this.numberOfSteps) {
      this.updateStep();
      return;
    }

    window.location.href = "/checkout/";
  }

  /**
   * Go to previous step (click on back button)
   */
  previousStep() {
    // Check if step is a gift step
    let isGiftStep =
      this.querySelector(
        `[data-step-index="${this.current_step}"].gifts-cart--step`
      ) || false;

    if (isGiftStep) {
      this.current_step = 0;
      this.updateStep();
      return;
    }
    this.current_step--;
    this.updateStep("previous");

    if (reassuranceOnlyFirstStep && this.current_step == 0) {
      document.querySelector(".sidecart-form__slider_form")
        ? document
          .querySelector(".sidecart-form__slider_form")
          .classList.remove("hidden")
        : null;
    }
  }

  /**
   * Update step
   */
  updateStep(step = "next") {
    if (step == "gift") {
      this.querySelectorAll("[data-step-index]").forEach((step) =>
        step.classList.remove("active")
      );

      this.querySelectorAll(
        `[data-step-index="${this.current_step}"]:not(.gifts-cart--step)`
      ).forEach((item) => item.classList.add("active"));

      this.querySelector(
        '.gifts-cart--step[data-gift-number="' + this.gift_index + '"]'
      ).classList.add("active");

      document
        .querySelector('button[data-action-type="gifts"]')
        .classList.add("active");

      return;
    }
    this.querySelectorAll("[data-step-index]").forEach((step) =>
      step.classList.remove("active")
    );

    this.querySelectorAll(`[data-step-index="${this.current_step}"]`).forEach(
      (item) => item.classList.add("active")
    );

    // Check if featured product is in cart, if so, go to next step
    let isFeaturedProduct =
      this.querySelector(
        `[data-step-index="${this.current_step}"].sidecart__featured-product`
      ) || false;

    // Check if step is a gift step
    let isGiftStep =
      this.querySelector(
        `[data-step-index="${this.current_step}"].gifts-cart--step`
      ) || false;

    // Check if step is a subscription step
    let isSubscription =
      this.querySelector(
        `[data-step-index="${this.current_step}"].sidecart__subscription`
      ) || false;

    if (isFeaturedProduct) {
      let hasProductInCart =
        isFeaturedProduct.dataset.hasProduct == "true" ? true : false;
      if (hasProductInCart && step == "next") {
        this.nextStep();
      } else if (hasProductInCart && step == "previous") {
        this.previousStep();
      }
    }

    const progressBarsContainer = this.querySelector(
      ".sidecart__footer-progressbar"
    );

    const shippingCostContainer = this.querySelector(
      ".sidecart__footer-shipping"
    );

    // Hide progress bar if step is a gift step or Featured product step
    if (isGiftStep || isFeaturedProduct || isSubscription) {
      progressBarsContainer.classList.add("hidden");
      shippingCostContainer.classList.add("hidden");
    } else {
      progressBarsContainer.classList.remove("hidden");
      shippingCostContainer.classList.remove("hidden");
    }

    // Update css Variables
    const sideCart = document.querySelector("side-cart");
    sideCart.initCssVariables();

    // check if step is gift step and hide footer
    // TODO :
    //  //  //  // Check if we need to have footer or not
    //
    // if (isGiftStep) {
    //   this.querySelector(".sidecart__footer").classList.add("hidden");
    // } else {
    //   this.querySelector(".sidecart__footer").classList.remove("hidden");
    //

    if (isGiftStep) {
      if (step == "next" || !step) {
        this.nextStep(false);
      } else {
        this.previousStep();
      }
    }

    // Check if step is subscription and click on subscription switch
    if (isSubscription && !this.subscriptionLoaded) {
      this.subscriptionLoaded = true;

      // check if products in cart has selling_plan and if so, click on subscription switch or pass to next step

      let has_selling_plan = false;
      for (const item of this.cart.items) {
        console.log(item);
        if (
          selling_plans[item.handle] &&
          selling_plans[item.handle].plans != {}
        ) {
          has_selling_plan = true;
        }
      }

      if (has_selling_plan) {
        this.querySelector(".subscription-upsell__subscribe").click();
      } else {
        if (step == "next") {
          this.nextStep();
        } else {
          this.previousStep();
        }
      }
    }

    if (this.current_step == 0 && !isGiftStep && step == "previous") {
      if (document.querySelector(".subscription-upsell__oneshot"))
        document.querySelector(".subscription-upsell__oneshot").click();
    }

    if (!isSubscription) {
      this.subscriptionLoaded = false;
    }
  }

  /**
   * Add featured product to cart
   * @param {object} evt - Event object.
   */
  addFeaturedProduct(evt) {
    const step_content = this.querySelector(
      ".sidecart__featured-product.active"
    );

    evt.currentTarget.classList.add("cart-item--loading");
    evt.currentTarget.classList.add("is-loading");

    const product_handle = step_content.dataset.productHandle;
    const variant_id = step_content.dataset.variantId;
    const is_subscription =
      step_content.dataset.isSubscription == "true" ? true : false;
    const subscription_frequency = step_content.dataset.subscriptionFrequency;

    let item = {
      id: variant_id,
      quantity: 1,
    };

    if (is_subscription) {
      const selling_plan_id =
        selling_plans[product_handle].plans[subscription_frequency];
      item["selling_plan"] = selling_plan_id;
    }

    document.querySelector("cart-items").dispatchEvent(
      new CustomEvent("cart-items:add", {
        detail: {
          item: item,
          callback: document.querySelector(
            `[data-step-index="${this.current_step + 1
            }"][data-action-type="gifts"]`
          )
            ? null
            : this.nextStep.bind(this),
        },
      })
    );
  }

  /**
   * Subscribe actions
   * @param {object} evt - Event object.
   */
  subscribeActions(evt) {
    let subscription_bool = evt.currentTarget.dataset.subscribe == "true";
    let subscription_upsell = document.querySelector("subscription-upsell");
    let switcher_subscribe = subscription_upsell.querySelector(
      ".subscription-upsell__subscribe"
    );
    let switcher_one_time = subscription_upsell.querySelector(
      ".subscription-upsell__oneshot"
    );

    if (subscription_bool) {
      subscription_upsell.dispatchEvent(
        new CustomEvent("subscription-upsell:subscribe")
      );
    } else {
      subscription_upsell.dispatchEvent(
        new CustomEvent("subscription-upsell:oneshot")
      );
    }
  }

  updateFeaturedProductStatus(item) {
    const featured_product = this.querySelector(
      `.sidecart__featured-product[data-variant-id="${item.id}"]`
    );
    if (featured_product) {
      featured_product.dataset.hasProduct = item.quantity > 0 ? "true" : false;
    }
  }
}

customElements.define("side-cart", SideCart);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.initVariables();
    this.bindEvents();

    this.addEventListener(
      "cart-items:bind-events",
      function () {
        this.initVariables();
        this.bindEvents();
      }.bind(this)
    );

    this.addEventListener(
      "cart-items:add",
      function (evt) {
        this.fetchAddToCart(evt.detail);
      }.bind(this)
    );

    this.addEventListener(
      "cart-items:update",
      function (evt) {
        this.fetchUpdateCart(
          evt.detail.key,
          evt.detail.quantity,
          evt.detail.item_to_add ? evt.detail.item_to_add : null,
          evt.detail.nextStep ? evt.detail.nextStep : null
        );
      }.bind(this)
    );
  }

  /**
   * init all variables used in side cart
   */
  initVariables() {
    this.body = document.querySelector("body");
    this.cartItems = this.querySelectorAll(".cart-item");
    this.sideCart = document.querySelector("side-cart");
  }

  /**
   * bind all events used in side cart
   */
  bindEvents() {
    this.cartItems.forEach((item) => {
      let minus_quantity = item.querySelector('button[name="minus"]');
      let plus_quantity = item.querySelector('button[name="plus"]');

      if (minus_quantity) {
        minus_quantity.addEventListener(
          "click",
          this.decreaseQuantity.bind(this)
        );
      }
      plus_quantity.addEventListener("click", this.increaseQuantity.bind(this));

      let removeGiftBtn = item.querySelector('button[name="remove-gift"]');

      if (removeGiftBtn) {
        removeGiftBtn.addEventListener("click", (e) => {
          const variant_id = item.getAttribute("data-variant-id");
          let step_gift = document.querySelector(
            `.gifts-cart--step [data-current-gift-id="${variant_id}"]`
          );
          if (step_gift) {
            step_gift.querySelector(".gift-item__remove-next").click();
          }
        });
      }
    });
  }

  /**
   * update cart when udpate quantity
   * @param {string} key - Key of line item.
   * @param {number} quantity - Quantity of variant.
   */
  async fetchUpdateCart(key, quantity, item_to_add = null, next_step = null) {
    let data = {
      updates: {
        [key]: quantity,
      },
    };

    let response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    try {
      let cart = await response.json();
      if (item_to_add == null) this.updateCart(cart);
      this.sideCart.updateFeaturedProductStatus({
        id: this.querySelector(`.cart-item[data-item-key="${key}"]`).dataset
          .variantId,
        quantity: quantity,
      });
    } catch (error) {
      console.log(error);
    }

    if (item_to_add) {
      document.querySelector("cart-items").dispatchEvent(
        new CustomEvent("cart-items:add", {
          detail: {
            item: item_to_add,
          },
        })
      );
    }

    if (next_step) {
      this.sideCart.nextStep();
    }
  }

  /**
   * Fetch add to cart item
   * @param {object} item - Item to add to cart.
   */
  async fetchAddToCart(detail) {
    let response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(detail.item),
    });

    try {
      let cart = await response.json();
      this.updateCart(cart, true);
      if (detail.callback) {
        detail.callback();
      }

      this.sideCart.updateFeaturedProductStatus(detail.item);
      this.sideCart.updateCartCount();

      let _item = {
        AddedItemProductName: cart.product_title,
        AddedItemProductID: `${cart.product_id}`,
        AddedItemSKU: cart.sku,
        AddedItemPrice: cart.final_price / 100,
        AddedItemURL: cart.url,
        AddedItemImageURL: cart.image,
        $use_ip: true,
        $is_session_activity: true,
      };

      setTimeout(
        function () {
          this.productAdded(_item);
        }.bind(this),
        3000
      );

      if (detail.openCart) {
        this.sideCart.classList.add("sidecart--open");
        document.querySelector("body").classList.add("shadow-cart");
      }
    } catch (error) {
      console.log(error);
    }
  }

  productAdded(_item) {
    fetch(`${window.location.origin}/cart.js`).then((res) =>
      res
        .clone()
        .json()
        .then((data) => {
          var cart = {
            total_price: data.total_price / 100,
            $value: data.total_price / 100,
            total_discount: data.total_discount,
            original_total_price: data.original_total_price / 100,
            items: data.items,
          };

          if (_item !== "undefined") {
            cart = Object.assign(cart, _item);
          }
        })
    );
  }

  /**
   * decrease quantity of product
   * @param {object} evt - Event object.
   */
  decreaseQuantity(evt) {
    let quantity_input = evt.currentTarget.parentNode.querySelector(
      'input[name="updates[]"]'
    );

    let item = quantity_input.closest("[data-item-key]");

    if (quantity_input.value > 0) {
      quantity_input.value--;
    }

    item.classList.add("cart-item--loading");

    this.fetchUpdateCart(item.dataset.itemKey, quantity_input.value);
  }

  /**
   * increase quantity of product
   * @param {object} evt - Event object.
   */

  increaseQuantity(evt) {
    let quantity_input = evt.currentTarget.parentNode.querySelector(
      'input[name="updates[]"]'
    );

    let item = quantity_input.closest("[data-item-key]");

    quantity_input.value++;

    item.classList.add("cart-item--loading");

    this.fetchUpdateCart(
      quantity_input.closest("[data-item-key]").dataset.itemKey,
      quantity_input.value
    );
  }

  /**
   * update cart when add or remove product
   * @param {object} cart - Cart object.
   * @param {boolean} new_item_added - Whether a new item was added to the cart.
   */
  updateCart(cart, new_item_added = false) {
    document.querySelector("side-cart").dispatchEvent(
      new CustomEvent("dispatch:cart-drawer:refresh", {
        detail: {
          cart: cart,
          new_item_added: new_item_added,
        },
      })
    );
  }
}

customElements.define("cart-items", CartItems);

class QuickAddtoCart extends HTMLElement {
  constructor() {
    super();

    this.variant_id = this.dataset.variantId;

    this.querySelector("button.add-to-cart")?.addEventListener(
      "click",
      this.addToCart.bind(this)
    );

    this.querySelector('button[name="plus"]')?.addEventListener(
      "click",
      this.increaseQuantity.bind(this)
    );

    this.querySelector('button[name="minus"]')?.addEventListener(
      "click",
      this.decreaseQuantity.bind(this)
    );

    this.cartItems = document.querySelector("cart-items");
  }

  /**
   * Fetch add to cart item
   * @param {event} event - event object.
   */
  async addToCart(event) {
    event.preventDefault();

    event.currentTarget.classList.add("cart-item--loading", "is-loading");

    let item = {
      id: this.variant_id,
      quantity: 1,
    };

    document.querySelector("cart-items").dispatchEvent(
      new CustomEvent("cart-items:add", {
        detail: {
          item: item,
          openCart: this.dataset.openCart ? true : false,
        },
      })
    );
  }

  /**
   * decrease quantity of product
   * @param {object} evt - Event object.
   */
  decreaseQuantity(evt) {
    this.cartItems.decreaseQuantity(evt);
  }

  /**
   * increase quantity of product
   * @param {object} evt - Event object.
   */
  increaseQuantity(evt) {
    this.cartItems.increaseQuantity(evt);
  }
}

customElements.define("quick-add-to-cart", QuickAddtoCart);

class GiftsCart extends HTMLElement {
  constructor() {
    super();

    this.initVariables();
    this.bindEvents();
  }

  /**
   * init all variables used in side cart
   */
  initVariables() {
    this.body = document.querySelector("body");
    this.gifts_products = document.querySelectorAll(
      ".gifts-cart:not(.gifts-cart--step)"
    );
    this.gifts_products_step = document.querySelectorAll(
      ".gifts-cart.gifts-cart--step"
    );
  }

  /**
   * bind all events used in side cart
   */
  bindEvents() {
    this.querySelectorAll(
      "button[data-has-gift]:not(.gift-item__remove-next)"
    ).forEach((button) => {
      button.addEventListener("click", this.addOrUpdateGift.bind(this));
    });

    this.querySelectorAll(".gift-item__remove-next").forEach((button) => {
      button.addEventListener("click", this.removeGift.bind(this));
    });

    this.addEventListener(
      "selectLastGift",
      function () {
        this.selectLastGift();
      }.bind(this)
    );

    this.querySelectorAll(".gift-item__button__select-modal").forEach(
      (button) => {
        button.addEventListener("click", this.openStepGift.bind(this));
      }
    );
  }

  /**
   * open step gift
   * @param {object} evt - Event object.
   */
  openStepGift(e) {
    e.preventDefault();
    let index = e.currentTarget.closest("[data-product]").dataset.product;

    const sidecart = document.querySelector("side-cart");
    sidecart.goGiftStep(index);
  }

  /**
   * select last gift
   */
  selectLastGift() {
    const gifts = document.querySelectorAll(
      ".gifts-cart:not(.gifts-cart--step) .gift-product[data-product]"
    );

    gifts.forEach((gift) => {
      const index = gift.dataset.product;
      const disabled =
        gift.getAttribute("disabled") == "disabled" ? true : false;
      const has_product = gift.querySelector("[data-key][data-has-gift]")
        ?.dataset.key
        ? true
        : false;

      const no_gift =
        localStorage.getItem(`gift_choice${index}`) == "false" ? true : false;

      if (!disabled && !has_product && no_gift == false) {
        const modal_gift = document.querySelector(
          `.gifts-cart.gifts-cart--step[data-gift-number="${index}"`
        );

        modal_gift
          .querySelector(".gift-product:first-child button[data-key]")
          .click();
      }
    });
  }

  /**
   * add or update gift
   * @param {object} evt - Event object.
   */
  addOrUpdateGift(evt) {
    let variant_id = evt.currentTarget.dataset.variantId;
    let key = evt.currentTarget.dataset.key;
    evt.currentTarget.classList.add("is-loading");

    let index =
      evt.currentTarget.closest("[data-gift-number]").dataset.giftNumber;
    let removeGiftButton = document.querySelector(
      `.gifts-cart--step[data-gift-number="${index}"] button[data-has-gift="true"]`
    );

    let has_gift = removeGiftButton ? true : false;

    let item = {
      id: variant_id,
      quantity: 1,
      properties: {
        "_is-gift": "true",
        "_gift-number": index,
      },
    };

    if (evt.currentTarget.closest(".gifts-cart--step")) {
      item.properties["_gift-manual"] = true;
    }

    if (has_gift) {
      // Update gift
      this.updateGift(
        {
          key: key,
          quantity: 0,
        },
        item
      );
      localStorage.removeItem(`gift_choice${index}`);

      return;
    }
    // Add gift
    this.addGift(item);

    // save localstorage customer choice
    localStorage.setItem(`gift_choice${index}`, "true");

    //evt.currentTarget.classList.remove("is-loading");
  }

  /**
   * update gift
   * @param {object} item - Change gift id
   * @param {object} item - Gift object.
   */
  updateGift(item_to_remove, item_to_add) {
    if (item_to_remove) {
      document.querySelector("cart-items").dispatchEvent(
        new CustomEvent("cart-items:update", {
          detail: {
            key: item_to_remove.key,
            quantity: 0,
            item_to_add: item_to_add,
          },
        })
      );
      return;
    }

    document.querySelector("cart-items").dispatchEvent(
      new CustomEvent("cart-items:add", {
        detail: {
          item: item_to_add,
        },
      })
    );
  }

  /**
   * add gift
   * @param {object} item - Gift object.
   */
  addGift(item) {
    document.querySelector("cart-items").dispatchEvent(
      new CustomEvent("cart-items:add", {
        detail: {
          item: item,
        },
      })
    );
  }

  /**
   * update gift price on card with country value
   * @param {object} gifts - Gifts object.
   */
  updateGiftPrice(gifts) {
    let i = 0;
    let index2 = 1;

    this.gifts_products_step.forEach((g) => {
      const gift_products = g.querySelectorAll(".gift-product");

      gift_products.forEach((gift_product) => {
        let gift_price = gift_product.querySelector("[data-gift-min-price]");
        let gift_price_value = gifts[index2];
        if (gift_price) {
          gift_price.innerHTML = `€${gift_price_value}`;
        }
        gift_product.setAttribute("data-gift-min-price", gift_price_value);
      });

      index2++;
    });

    this.gifts_products.forEach((g) => {
      const gift_products = g.querySelectorAll(".gift-product");

      gift_products.forEach((gift_product, index) => {
        let gift_price = gift_product.querySelector("[data-gift-min-price]");
        let gift_price_value = gifts[index + 1];
        if (gift_price) {
          gift_price.innerHTML = `€${gift_price_value}`;
        }
        gift_product.setAttribute("data-gift-min-price", gift_price_value);
      });
    });

    if (gifts.enable == false) {
      this.classList.add("hidden");
      return;
    }
  }

  /**
   * remove gift
   * @param {object} evt - Event object.
   */
  removeGift(evt) {
    evt.currentTarget.classList.add("is-loading");

    let index =
      evt.currentTarget.closest("[data-gift-number]").dataset.giftNumber;
    let key = evt.currentTarget
      .closest("gifts-cart")
      .querySelector("button[data-key]").dataset.key;

    localStorage.setItem(`gift_choice${index}`, "false");

    if (key) {
      document.querySelector("cart-items").dispatchEvent(
        new CustomEvent("cart-items:update", {
          detail: {
            key: key,
            quantity: 0,
            nextStep: false,
          },
        })
      );
    } else {
      //document.querySelector('[name="next-step"].active').click();
      evt.currentTarget.classList.remove("is-loading");
    }

    setTimeout(function () {
      const sidecart = document.querySelector("side-cart");
      sidecart.current_step = 0;
      sidecart.updateStep();
    }, 800);
  }
}

customElements.define("gifts-cart", GiftsCart);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    this.initVariables();
    this.bindEvents();
    this.initProgressBar();
  }

  /**
   * init all variables used in side cart
   */
  initVariables() {
    this.body = document.querySelector("body");
  }

  /**
   * bind all events used in side cart
   */
  bindEvents() {
    this.addEventListener(
      "progressbar:update",
      this.initProgressBar.bind(this)
    );
  }

  /**
   * init progress bar
   */
  initProgressBar() {
    this.isShipping = this.classList.contains("shipping-progress-bar")
      ? true
      : false;
    this.isGift = this.classList.contains("gift-progress-bar") ? true : false;

    if (this.isShipping) {
      this.shippingProgressBar();
    } else if (this.isGift) {
      this.giftProgressBar();
    }
  }

  async getCountryLocation(resolve) {
    const geoData = await Geolizr?.geo?.getData();
    const current_country = geoData?.country.code;
    this.country = current_country;
    this.country_object = countryObject[this.country];
    return await resolve();
  }

  /**
   * init shipping progress bar
   */
  async shippingProgressBar() {
    if (!this.country || !this.country_object) {
      await new Promise(
        function (resolve) {
          this.getCountryLocation(resolve);
        }.bind(this)
      );
    }

    this.calculateShippingProgress();
  }

  /**
   * calculate shipping progress
   */
  calculateShippingProgress() {
    let cart = document.querySelector("side-cart").cart;

    if (!cart) {
      setTimeout(this.calculateShippingProgress.bind(this), 200);
      return;
    }

    let cart_total_price = cart.total_price / 100;
    let shipping_start = this.country_object.shipping_start;
    let shipping_cost = this.country_object.shipping_cost;
    let shipping_progress = this.querySelector("progress");

    // calculate on percentage of shipping
    let shipping_progress_value =
      ((cart_total_price / shipping_start) * 100) / 100;

    // get min 0 and max 100 to shipping progress_value and set it
    shipping_progress_value = Math.min(Math.max(shipping_progress_value, 0), 1);
    shipping_progress.value = shipping_progress_value;

    if (
      typeof SHIPPING_PRICE_OVERWRITE != "undefined" &&
      this.country == "FR"
    ) {
      shipping_cost = SHIPPING_PRICE_OVERWRITE;
    }
    this.updateShippingPrice(cart_total_price, shipping_start, shipping_cost);
  }

  /**
   * update shipping price
   */
  updateShippingPrice(cart_total_price, shipping_free_amount, shipping_cost) {
    // Update shipping price
    let footer_shipping_price = document.querySelector(
      ".sidecart__footer-shipping [data-shipping-price]"
    );
    let free_shipping_label = document.querySelector(
      ".sidecart__footer-shipping [data-free-shipping]"
    ).dataset.freeShipping;

    // Check if shipping is free and set label to free shipping or shipping cost

    if (
      cart_total_price >= shipping_free_amount &&
      !document.querySelector(".sidecart__empty-header")
    ) {
      footer_shipping_price.innerHTML = free_shipping_label;
      document.querySelector(".gifts-cart")?.classList.remove("hidden");
    } else {
      footer_shipping_price.innerHTML = `€${shipping_cost.toFixed(2)}`;
      if (
        document.querySelector(".gifts-cart") &&
        (!document
          .querySelector(".gifts-cart")
          .classList.contains("gifts-cart--force-display") ||
          cart_total_price == 0)
      ) {
        document.querySelector(".gifts-cart")?.classList.add("hidden");
      } else {
        document.querySelector(".gifts-cart")?.classList.remove("hidden");
      }
    }

    if (
      document.querySelector(".gift-progress-bar") &&
      !document
        .querySelector(".gift-progress-bar")
        .classList.contains("hidden") &&
      !document.querySelector(".sidecart__empty-header")
    ) {
      document.querySelector(".gifts-cart")?.classList.remove("hidden");
    }

    // Update remaining amount to free shipping
    let remaining_amount = shipping_free_amount - cart_total_price;
    let remaining_amount_text = document.querySelector(
      "[data-remaining-free-shipping]"
    );

    if (remaining_amount < 0) {
      remaining_amount = 0;
      this.querySelector(
        ".shipping-progress-bar .sidecart__footer-progressbar-text"
      ).classList.add("hidden");
    }

    remaining_amount_text.innerHTML = `€${remaining_amount.toFixed(2)}`;

    this.updateProgressBarVisibility();
  }

  updateProgressBarVisibility() {
    let has_gift_progress_bar =
      document.querySelector(".gift-progress-bar") || false;

    let gifts_enable = this.country_object.shipping_gift_enable;

    const remaining_shipping = parseFloat(
      document
        .querySelector("[data-remaining-free-shipping]")
        .innerHTML.replace("€", "")
    );
    const remaining_gift = document.querySelector("[data-remaining-free-gift]")
      ? parseFloat(
        document
          .querySelector("[data-remaining-free-gift]")
          .innerHTML.replace("€", "")
      )
      : null;

    if (has_gift_progress_bar && gifts_enable) {
      // check remaining_shipping if value is NaN
      if (isNaN(remaining_shipping) || isNaN(remaining_gift)) {
        return setTimeout(this.updateProgressBarVisibility.bind(this), 200);
      }

      if (
        (remaining_gift > remaining_shipping ||
          (remaining_shipping > 0 && remaining_gift <= 0)) &&
        remaining_shipping != 0
      ) {
        document
          .querySelector(".shipping-progress-bar")
          .classList.remove("hidden");
        document.querySelector(".gift-progress-bar").classList.add("hidden");
      } else {
        document
          .querySelector(".shipping-progress-bar")
          .classList.add("hidden");
        document.querySelector(".gift-progress-bar").classList.remove("hidden");
      }
    } else if (!gifts_enable) {
      document.querySelector(".gift-progress-bar").classList.add("hidden");
    }
  }

  /**
   * init gift progress bar
   */
  async giftProgressBar() {
    if (!this.country || !this.country_object) {
      await new Promise(
        function (resolve) {
          this.getCountryLocation(resolve);
        }.bind(this)
      );
    }

    const gifts = {
      enable: this.country_object.shipping_gift_enable,
      1: this.country_object.shipping_gift_amount_min_1,
      2: this.country_object.shipping_gift_amount_min_2,
      3: this.country_object.shipping_gift_amount_min_3,
    };

    for (var i = 1; i <= 3; i++) {
      let product_item = document.querySelector(
        `gifts-cart [data-product="${i}"]`
      );
      if (!product_item) {
        gifts[i] = null;
      }
    }

    document.querySelectorAll("gifts-cart").forEach(function (el) {
      el.updateGiftPrice(gifts);
    });

    if (gifts.enable == false) {
      this.classList.add("hidden");
    }

    this.updateRemainingGifts(gifts);
  }

  /**
   * update remaining gifts
   * @param {object} gifts - Gifts object.
   */
  updateRemainingGifts(gifts) {
    let current_gift = 1;
    let cart_total_price = parseFloat(this.dataset.cartPrice);
    let progress_bar = this.querySelector("progress");
    let amount_min = 0;
    let amount_max = 0;

    current_gift = this.getCurrentGift(cart_total_price, gifts);

    document
      .querySelectorAll(".gift-progress-bar .sidecart__footer-progressbar-text")
      .forEach((el) => {
        el.classList.add("hidden");
      });

    document
      .querySelector(
        ".gift-progress-bar .sidecart__footer-progressbar-text--" + current_gift
      )
      .classList.remove("hidden");

    const price_min_shipping = this.country_object.shipping_start;
    const price_min_gift =
      current_gift == 1 ? gifts[current_gift] : gifts[current_gift - 1];

    if (price_min_shipping < gifts[0]) {
      if (current_gift == 1) {
        amount_min = price_min_shipping;
        amount_max = price_min_gift;
      } else {
        amount_min = price_min_gift;
        amount_max = gifts[current_gift];
      }
    } else {
      if (current_gift == 1) {
        amount_max = price_min_gift;
        amount_min = 0;
      } else {
        amount_min = price_min_gift;
        amount_max = gifts[current_gift];
      }
    }

    let percentage =
      (cart_total_price - amount_min) / (amount_max - amount_min);

    progress_bar.value = percentage;

    // Update remaining amount to gift
    let remaining_amount = amount_max - cart_total_price;
    let remaining_amount_text = document.querySelectorAll(
      "[data-remaining-free-gift]"
    );

    remaining_amount_text.forEach((el) => {
      el.innerHTML = `€${remaining_amount.toFixed(2)}`;
    });

    if (remaining_amount < 0 || amount_max == null) {
      remaining_amount = 0;
      this.setAttribute("hidden", "hidden");
    }

    const all_steps_ended = this.getIfAllGiftsEnded(cart_total_price, gifts);
    const nb_gifts = this.getNbGifts(gifts);

    let gift_hidden = 0;
    for (var i = 1; i <= nb_gifts; i++) {
      let is_gift_removed =
        localStorage.getItem(`gift_choice${i}`) == "false" ? true : false;

      if (current_gift > i || all_steps_ended) {
        document
          .querySelectorAll(
            `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"]`
          )
          .forEach((item) => item.removeAttribute("disabled"));

        document
          .querySelectorAll(
            `.gifts-cart--step[data-gift-number="${i}"] .gift-product`
          )
          .forEach((item) => item.removeAttribute("disabled"));
      } else {
        let elements = document.querySelectorAll(
          `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"]`
        );

        if (GIFT_SHOW_ALL_STEPS) {
          elements.forEach((item) => item.removeAttribute("hidden"));
        } else {
          if (gift_hidden == 0) {
            elements.forEach((item) => item.removeAttribute("hidden"));
          } else {
            elements.forEach((item) => item.setAttribute("hidden", "hidden"));
          }
        }

        elements.forEach((item) => {
          item.setAttribute("disabled", "disabled");
        });

        document
          .querySelectorAll(
            `.gifts-cart--step[data-gift-number="${i}"] .gift-product`
          )
          .forEach((item) => item.setAttribute("disabled", "disabled"));

        gift_hidden++;
      }

      if (
        is_gift_removed &&
        document.querySelector(
          `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"] .gift-item__title`
        )
      ) {
        document.querySelector(
          `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"] .gift-item__title`
        ).innerHTML = "Je ne souhaite pas recevoir de cadeau";
        let image_src = document.querySelector(
          ".gifts-cart--step .gift-product:last-child img"
        ).src;

        document
          .querySelector(
            `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"] .gift-item__subtitle`
          )
          ?.classList.add("hidden");

        document.querySelector(
          `.gifts-cart:not(.gifts-cart--step) gifts-cart [data-product="${i}"] .gift-image`
        ).innerHTML = `<img src="${image_src}" alt="Image cadeau">`;
      } else {
        document
          .querySelector(
            `.gifts-cart:not(.gifts-cart--step) [data-product="${i}"] .gift-item__subtitle`
          )
          ?.classList.remove("hidden");
      }
    }

    this.checkGiftEligibility(cart_total_price, gifts);

    const sidecart = document.querySelector("side-cart");
    sidecart.initCssVariables();

    this.updateProgressBarVisibility();
  }

  /**
   * check gift eligibility and remove gift on cart if not eligible
   */
  checkGiftEligibility() {
    const gifts_container = document.querySelectorAll(
      ".gifts-cart:not(.gifts-cart--step) .gift-product[data-product]"
    );

    gifts_container.forEach((gift) => {
      let gift_product = gift.querySelector("button[data-key]");

      if (gift_product) {
        let gift_product_key = gift_product.dataset.key;
        let disabled = gift.getAttribute("disabled");

        if (disabled && gift_product_key) {
          document.querySelector("cart-items").dispatchEvent(
            new CustomEvent("cart-items:update", {
              detail: {
                key: gift_product_key,
                quantity: 0,
              },
            })
          );
        }
      }
    });

    document
      .querySelector("gifts-cart")
      .dispatchEvent(new CustomEvent("selectLastGift"));
  }

  /**
   * get number of gifts
   * @param {object} gifts - Gifts object.
   */
  getNbGifts(gifts) {
    let nb_gifts = 0;
    for (var i = 1; i <= 3; i++) {
      if (gifts[i] != null) {
        nb_gifts++;
      }
    }

    return nb_gifts;
  }

  /**
   * get if all gifts ended
   */
  getIfAllGiftsEnded() {
    let cart_total_price = parseFloat(this.dataset.cartPrice);
    let gifts = {
      1: this.country_object.shipping_gift_amount_min_1,
      2: this.country_object.shipping_gift_amount_min_2,
      3: this.country_object.shipping_gift_amount_min_3,
    };

    const nb_gift = document.querySelectorAll(
      ".gifts-cart:not(.gifts-cart--step) .gift-product[data-product]"
    ).length;

    if (gifts[nb_gift] <= cart_total_price) {
      return true;
    }

    return false;
  }

  /**
   * get current gift
   * @param {number} cart_total_price - Cart total price.
   * @param {object} gifts - Gifts object.
   */
  getCurrentGift(cart_total_price, gifts) {
    let current_gift = 1;

    if (cart_total_price >= gifts[2] && gifts[2] != null) {
      current_gift = 3;
    } else if (cart_total_price >= gifts[1] && gifts[1] != null) {
      current_gift = 2;
    }

    return current_gift;
  }
}

customElements.define("progress-bar", ProgressBar);
